if (!customElements.get('show-more-less')) {
  class ShowMoreLess extends HTMLElement {
    constructor() {
      super()

      this.$content = this.querySelector('[data-show-more-less-content]')
      this.$button = this.querySelector('[data-show-more-less-button]')

      if (this.$button) this.$button.addEventListener('click', this.toggleSeeMoreLess.bind(this))

      this.checkQuoteOverflow()

      if (!this.$content) return
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            this.checkQuoteOverflow()
          }
        }
      })
      resizeObserver.observe(this.$content)
    }

    get isExpanded() {
      return this.$content.classList.contains('!line-clamp-none')
    }

    toggleSeeMoreLess() {
      if (!this.$content || !this.$button) return
      this.$content.classList.toggle('!line-clamp-none')
      this.$content.classList.toggle('[&_p]:!my-0')
      this.$button.textContent = this.isExpanded ? 'See less' : 'See more'
    }

    checkQuoteOverflow() {
      if (!this.$content || !this.$button) return
      // Measure against the element's own rendered height so the check follows
      // whatever line-clamp the current breakpoint applies (2 on mobile, 3 from
      // xs up). The 1px slack absorbs sub-pixel line-height rounding.
      const isClamped = this.$content.scrollHeight > this.$content.clientHeight + 1
      // While expanded the content never overflows, but the button still has to
      // stay put so there is a way back to "See less".
      this.$button.classList.toggle('hidden', !this.isExpanded && !isClamped)
    }
  }

  customElements.define('show-more-less', ShowMoreLess)
}
